<template>
  <b-container fluid>
    <b-form @submit.stop.prevent="email_route">
      <b-form-group invalid-feedback="Must be greater then 4 character">
        <b-form-input v-model="email" autocomplete='email' type='email' required placeholder="Email"></b-form-input>
      </b-form-group>

      <LoadingButton variant="primary" :loading="loading" block @click="email_route">Next</LoadingButton>
    </b-form>
  </b-container>
</template>

<script>

import { db, auth, _firebase, analytics, remote_config } from '@/main.js'
import AuthMixin from "@/mixins/Auth.js"
import Tracking from '@/mixins/Tracking.js'

export default {
  metaInfo: {title: 'Login'},
  mixins: [AuthMixin, Tracking],
  props: ['profile'],
  data() {
    return {
      email: this.$route.params.email || this.$route.query.email || '',
      plan: this.$route.params.plan || this.$route.query.plan || null,
      loading: false
    }
  },
  methods: {
    async email_route() {
      this.loading = true
      let email = this.email.trim().toLowerCase()

      let latest_recording
      try {
        // eslint-disable-next-line
        latest_recording = FS.getCurrentSessionURL()
      } catch(err) {
        // pass
      }

      let visitor = null
      try {
        visitor = await this.tracking_data(true)
      } catch(err) {
        console.warn(err)
        // pass
      }

      // TODO extensions: visitor.extensions,
      analytics.identify(email, {email: email, latest_recording: latest_recording, utc_offset: visitor.utc_offset, ip_country: visitor.country})

      let result
      try {
        result = await auth.fetchSignInMethodsForEmail(email)
      } catch (error) {
        this.loading = false
        return this.$swal({title: 'Try again', text: error.message, icon: 'warning'})
      }

      let has_google = false
      if (result.indexOf('google.com') > -1) {
        has_google = true
      }

      if (result.indexOf('google.com') > -1 || result.indexOf('password') > -1) {
        this.loading = false
        this.$router.push({name: 'login_login', params: {has_google, from_email: email}})
        return
      }

      if (remote_config.getValue('require_demo').asBoolean() === false) {
        this.loading = false
        this.$router.push({name: 'login_signup'})
        return
      }

      let domain = email.split('@')[1]
      let email_doc = await db.collection('email_whitelist').doc(domain).get()
      if (email_doc.data()) {
        this.loading = false
        this.$router.push({name: 'login_signup', params: {from_email: email}})
        return
      }

      email_doc = await db.collection('email_whitelist').doc(email).get()
      if (email_doc.data()) {
        this.loading = false
        this.$router.push({name: 'login_signup'})
        return
      }

      this.loading = false
      this.$router.push({name: 'login_demo'})
    },
  },
  created() {
    let visitor = null
    try {
      this.tracking_data(true)
    } catch(err) {
      console.warn(err)
      // pass
    }
  }
}
</script>

<style scoped>

</style>
